import { render, staticRenderFns } from "./WaterGold.vue?vue&type=template&id=7b2c6d00"
import script from "./WaterGold.vue?vue&type=script&lang=js"
export * from "./WaterGold.vue?vue&type=script&lang=js"
import style0 from "./WaterGold.vue?vue&type=style&index=0&id=7b2c6d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports